import AddAPhotoIcon from '@mui/icons-material/AddAPhoto';
import SupportAgentIcon from '@mui/icons-material/SupportAgent';
import {Box, Button, Divider} from '@mui/material';
import {useTranslation} from 'react-i18next';
import {useCurrentPatient} from '@/patient/context/CurrentPatientContext';
import {useDiagnosticReportFormModalContext} from '@/patient/context/DiagnosticReportFormModalContext';
import {useConditions} from '@/patient/hooks/useConditions';
import CompanyLogo from '@/shared/components/layout/LoggedInLayout/Sidebar/CompanyLogo';
import {Menu} from '@/shared/components/layout/LoggedInLayout/Sidebar/Menu';
import {SidebarWrapper} from '@/shared/components/layout/LoggedInLayout/Sidebar/styledComponents';
import InvestigatorManualButton from '@/shared/components/ui/InvestigatorManualButton';
import {useCompany} from '@/shared/contexts/UserContext/useUserContext';
import patientMenuItems from './menu';

export default function PatientSidebar({onCloseSidebar}: {onCloseSidebar?: () => void}) {
  const patient = useCurrentPatient();
  const company = useCompany();
  const conditions = useConditions();
  const investigatorManualUrl = 'https://jnj-77242113.legit.health/for-patients/capture-and-upload';
  const {t} = useTranslation(['shared/common', 'patient/common', 'shared/medicationRequest']);
  const menuItems = patientMenuItems(patient, company, conditions);
  const openDiagnosticReportFormModal = useDiagnosticReportFormModalContext();

  function handleUploadPhotoClick() {
    onCloseSidebar?.();
    openDiagnosticReportFormModal();
  }
  return (
    <SidebarWrapper>
      <Box
        sx={{
          position: 'sticky',
          top: 15
        }}
      >
        <CompanyLogo company={company} />
        <Menu menuItems={menuItems} onCloseSidebar={onCloseSidebar} t={t} />{' '}
        {patient.isAllowedToUploadPhotos && (
          <Box
            sx={{
              my: 2
            }}
          >
            <Button
              startIcon={<AddAPhotoIcon />}
              fullWidth
              onClick={handleUploadPhotoClick}
              color="primary"
              variant="contained"
              disableElevation
            >
              {t('patient/common:menu.upload')}
            </Button>
          </Box>
        )}
        <Divider sx={{width: '100%'}} />
        <Box
          sx={{
            my: 2
          }}
        >
          {company.isForClinicalTrials ? (
            <InvestigatorManualButton href={investigatorManualUrl} />
          ) : (
            <Button
              startIcon={<SupportAgentIcon />}
              fullWidth
              component="a"
              href="https://legit.health/support-for-patients"
              color="secondary"
              variant="outlined"
              target="_blank"
            >
              {t('shared/common:support.label')}
            </Button>
          )}
        </Box>
      </Box>
    </SidebarWrapper>
  );
}
